import { observer } from "mobx-react-lite";
import { Popup } from "antd-mobile";
import styled from "styled-components";
import { useStores } from "../../models";
import { payTypeImage, payTypeLabel } from "./types";

const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 20px 16px 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-top: 1px solid rgb(200, 200, 200);
  cursor: pointer;
  &:active {
    background: #f5f5f5;
  }
`;

const Label = styled.div`
  flex: 1;
  margin-left: 10px;
  font-size: 16px;
`;

const Close = styled.div`
  position: absolute;
  right: 16px;
  top: 14px;
  color: rgb(200, 200, 200);
  cursor: pointer;
`;

type Props = {
  visible: boolean;
  setVisible: (v: boolean) => void;
  title?: string;
  paymentMethods?: number[];
  callBack: (payment: any) => void;
};

const PayTypeModal = ({
  visible,
  setVisible,
  title = "选择付款方式",
  paymentMethods = [],
  callBack,
}: Props) => {
  const { walletStore } = useStores();
  const methods = paymentMethods || [];

  return (
    <Popup
      visible={visible}
      onMaskClick={() => setVisible(false)}
      bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, paddingBottom: 40 }}
    >
      <div style={{ position: "relative" }}>
        <Close onClick={() => setVisible(false)}>关闭</Close>
        <Title>{title}</Title>
        {(walletStore.paymentList || []).map((payment: any, i: number) => {
          if (methods.length && !methods.includes(payment.pay_type)) return null;
          return (
            <Row
              key={`${payment.pay_type}-${payment.pay_account}-${i}`}
              onClick={() => {
                setVisible(false);
                callBack(payment);
              }}
            >
              <img
                src={payTypeImage(payment.pay_type)}
                alt=""
                width={20}
                height={20}
                style={{ borderRadius: 4 }}
              />
              <Label>
                {payTypeLabel(payment.pay_type)} {payment.pay_account}
              </Label>
              <span style={{ color: "rgb(170,170,170)" }}>›</span>
            </Row>
          );
        })}
      </div>
    </Popup>
  );
};

export default observer(PayTypeModal);
